import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '@/data/blog/posts';

/* =====================================================================
   BlogCard — yazı kartı (/blog listesi, ana sayfa, ilgili yazılar).
   Kapaklar küçük stok görseller (~300px) → büyütüp bulanıklaştırmamak için
   görsel yanda, sabit genişlikte durur.
   ===================================================================== */

const BlogCard = ({ post, headingLevel: Heading = 'h2' }) => (
  <Link
    to={`/blog/${post.slug}`}
    className="group flex gap-4 rounded-2xl border border-hairline bg-surface p-3 transition-shadow hover:shadow-card-lift focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 sm:gap-5 sm:p-4"
  >
    <img
      src={post.cover.src}
      width={post.cover.width}
      height={post.cover.height}
      alt={post.cover.alt}
      loading="lazy"
      decoding="async"
      className="aspect-[4/5] w-24 flex-shrink-0 rounded-xl object-cover sm:w-36"
    />
    <div className="flex min-w-0 flex-col justify-center py-1">
      <p className="mb-1.5 font-inter text-xs text-ink-muted">
        <time dateTime={post.date}>{formatDate(post.date)}</time> · {post.readMinutes} dk okuma
      </p>
      <Heading className="text-balance font-poppins text-base font-semibold leading-snug text-ink-strong group-hover:text-brand-700 sm:text-lg">
        {post.title}
      </Heading>
      <p className="mt-2 line-clamp-3 font-inter text-sm leading-relaxed text-ink-muted">{post.excerpt}</p>
    </div>
  </Link>
);

export default BlogCard;
